import { Injectable } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DataFormModel } from '../models/data-form-model.model';
import { Table } from 'primeng/table';
import { ToastService } from './toast.service';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  constructor(
    private formBuilder: FormBuilder,
    public toastService: ToastService,
  ) { }

  /* -------------------------------------------------------------------------- */
  /*                             ANCHOR base64ToBlob                            */
  /* -------------------------------------------------------------------------- */
  // region base64ToBlob
  base64ToBlob(
    base64: string,
  ): Blob {

    const byteString = atob(base64);
    const len = byteString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) bytes[i] = byteString.charCodeAt(i);

    return new Blob([bytes], { type: 'image/jpeg' });
  }

  /* -------------------------------------------------------------------------- */
  /*                             ANCHOR base64ToFile                            */
  /* -------------------------------------------------------------------------- */
  // region base64ToFile
  base64ToFile(
    base64: string,
    fileName: string
  ): File {

    const arr = base64.split(',');
    const mimeMatch = arr[0].match(/:(.*?);/);

    if (!mimeMatch) {
      throw new Error('Base64 inválido');
    }

    const mime = mimeMatch[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File(
      [u8arr],
      fileName,
      { type: mime }
    );

  }

  /* -------------------------------------------------------------------------- */
  /*                              ANCHOR clearTable                             */
  /* -------------------------------------------------------------------------- */
  // region clearTable
  clearTable(table: Table) {
    table.clear();
  }

  /* -------------------------------------------------------------------------- */
  /*                              ANCHOR objectKeys                             */
  /* -------------------------------------------------------------------------- */
  // region objectKeys
  objectKeys(obj: any) {
    return Object.keys(obj);
  }

  /* -------------------------------------------------------------------------- */
  /*                              ANCHOR buildForm                              */
  /* -------------------------------------------------------------------------- */
  // region buildForm
  buildForm(obj: DataFormModel): FormGroup {

    const group: { [key: string]: FormControl } = {};

    Object.keys(obj).forEach(key => {
      group[key] = new FormControl(obj[key].value, obj[key].validators);
    });

    return new FormGroup(group);
    
  }

  /* -------------------------------------------------------------------------- */
  /*                              ANCHOR censorText                             */
  /* -------------------------------------------------------------------------- */
  // region censorText
  censorText(str: string): string {
    return str.replace(/./g, '*');
  }

  /* -------------------------------------------------------------------------- */
  /*                           ANCHOR copyToClipboard                           */
  /* -------------------------------------------------------------------------- */
  // region copyToClipboard
  copyToClipboard(text: string) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);

    this.toastService.show({
      body: 'Copiado en el portapapeles',
      classname: 'bg-dark text-white',
    });
  }

  /* -------------------------------------------------------------------------- */
  /*                            ANCHOR formatCurrency                           */
  /* -------------------------------------------------------------------------- */
  // region formatCurrency
  formatCurrency(amount: number, currency: string = 'USD', locale: string = 'en-US'): string {
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(amount);
  }

  /* -------------------------------------------------------------------------- */
  /*                               ANCHOR headers                               */
  /* -------------------------------------------------------------------------- */
  // region headers
  headers(
    token: string
  ): HttpHeaders {
    return new HttpHeaders({
      'Authorization': token,
      'Content-Type': 'application/json'
    });
  }

}
